import { apiRequest, getResource } from "../api/http";

// Statistics per rubric (category): overview, one rubric in detail, AI summary.
const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** Every rubric over `{ period, start, end, fresh }`; rejects on failure. */
export const getCategoryStats = (params) => getResource(`/api/admin/category-stats${query(params)}`, { rethrow: true });

/** One rubric: figures against the platform, insights, comment sentiment, videos. Rejects on failure. */
export const getCategoryDetail = (id, params) => getResource(`/api/admin/category-stats/${id}${query(params)}`, { rethrow: true });

/** Summary written by the AI (kept 24 h; `regenerate` writes it again). Rejects with the API message. */
export const writeCategorySummary = (id, params, regenerate = false) =>
  apiRequest("post", `/api/admin/category-stats/${id}/ai-summary${query(params)}`, { data: { regenerate }, rethrow: true });
